import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { RouterLink } from '@angular/router';
import { SeoService } from '@out-web/core';

@Component({
  selector: 'out-sell-my-tesla',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './sell-my-tesla.component.html',
  styleUrl: './sell-my-tesla.component.scss',
})
export class SellMyTeslaComponent implements OnInit {
  constructor(
    private seoService: SeoService,
    private route: ActivatedRoute,
    private auth: AuthService
  ) { }

  ngOnInit(): void {
    this.setMetaData();
  }

  private setMetaData(): void {
    const title = 'Sell My Tesla Online | Sell Your Tesla | Only Used Tesla';
    const description = 'List your Tesla in minutes, reach 100 K+ buyers, and close safely with verified docs & dealer cash-offer options';
    const imageUrl = 'https://onlyusedtesla.com/assets/images/meta-logo.png';
    const url = 'https://onlyusedtesla.com/sell-my-tesla';

    this.seoService.setMetaData(title, description, imageUrl, url);
  }

  Login(): void {
    this.auth.loginWithRedirect();
  }
}
